const defaultMapper = (v: string) => v

/**
 * Conditionally join class names together.
 */
export function classJoin(classes: Record<string, unknown>, mapper = defaultMapper) {
    return Object.keys(classes)
        .filter(k => classes[k])
        .map(mapper)
        .join(" ")
}
